module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921121151_T.2f167dcb.jpg";